module.exports = __webpack_public_path__ + "static/empty.29cf4ea7.png";